export const siteInfo = {
  name: '爆料看料',
  fullName: '爆料看料 · 深扒观察室',
  tagline: '深扒本质 · 理性看料',
  intro:
    '爆料看料是一个专注深度拆解的内容平台。我们不追最快的第一现场，而是喜欢慢一点，把散落各处的公开信息拼成完整脉络，起底事件的来龙去脉，拆解背后的关系与动机，让每一份「料」都经得起推敲。',
  email: 'contact@baoliaokanliao.cn',
  cooperation: 'hezuo@baoliaokanliao.cn',
  slogan: '穿透表象，看见事件的底层逻辑。',
  founded: '2019 年创刊',
};

export const navigation = [
  { label: '首页', path: '/' },
  { label: '专题分类', path: '/topics' },
  { label: '关于我们', path: '/about' },
];

export const stats = [
  { value: '1,286', label: '已完成深度拆解' },
  { value: '52万', label: '位理性读者' },
  { value: '5', label: '大内容主题' },
  { value: '72h', label: '单篇平均核查时长' },
];

export const methodSteps = [
  {
    index: '01',
    title: '线索收集',
    desc: '把公开报道、官方通报、行业数据与当事人的公开表述逐条归档，先不判断真假，只保证来源可追溯。',
  },
  {
    index: '02',
    title: '交叉验证',
    desc: '同一结论至少需要两条独立来源相互印证，孤证不立，冲突信息全部保留并标注，不擅自「圆场」。',
  },
  {
    index: '03',
    title: '关系拆解',
    desc: '把相关方梳理成关系图，找出利益链条、时间节点和关键转折，让事件的结构清晰可见。',
  },
  {
    index: '04',
    title: '结论克制',
    desc: '区分「已证实」「待观察」「纯推测」三种表述，不在证据不足时给出确定性判断。',
  },
];

export const testimonials = [
  {
    name: '周律',
    role: '内容从业者',
    content: '别的号在抢情绪，爆料看料在抢证据。看完它家的复盘，我改掉了团队里「先抢首发」的习惯。',
  },
  {
    name: '阿沁',
    role: '在读研究生',
    content: '像在读一篇有耐心的报道。时间线列得很清楚，来源也标出来了，不用再自己东拼西凑。',
  },
  {
    name: '王砚',
    role: '品牌市场负责人',
    content: '行业起底那一栏我每期都看，很多判断比内部复盘还早一步，写方案时直接当参考。',
  },
  {
    name: '陈拾',
    role: '自由撰稿人',
    content: '难得的是它愿意说「这件事目前无法确认」，而不是硬编一个结论出来，这在当下太稀缺了。',
  },
];

export const faqs = [
  {
    question: '爆料看料的信息来源是什么？',
    answer:
      '我们只使用公开可查的信息，主要包括官方通报、主流媒体报道、企业公开披露文件和当事人已公开发表的表述。所有关键信息在文中都会标注来源类型，不接受任何无法追溯的匿名爆料。',
  },
  {
    question: '内容会不会带节奏或者偏袒某一方？',
    answer:
      '我们要求同一事件中相关各方的公开表述都被完整引用，冲突之处会并列呈现而不是单方面采信。文章里会明确区分「已证实」「待观察」和「推测」，把判断的余地留给读者。',
  },
  {
    question: '多久更新一次深度内容？',
    answer:
      '常规更新保持每周二至五各一篇，周末出长文复盘。单篇深度拆解的平均核查周期在 72 小时左右，如果证据不足，我们宁可推迟也不会提前发布。',
  },
  {
    question: '可以投稿或者提供线索吗？',
    answer:
      '可以。我们欢迎提供有公开信息支撑的线索，请通过页脚的邮箱联系我们，并在标题注明「线索」。对于无法核实的内容我们不会采用，请理解这一点。',
  },
  {
    question: '文章里的结论可以直接引用吗？',
    answer:
      '欢迎引用并建议保留原文链接。但请连同文中的证据等级一起引用，避免把「推测」部分单独摘出当作事实传播，这是我们最在意的一条原则。',
  },
  {
    question: '会做付费内容或者广告吗？',
    answer:
      '深度长文永久免费阅读。我们靠少量品牌合作维持运营，所有合作内容都会在显著位置标注，独立选题不会因为合作而改变结论。',
  },
];

export const principles = [
  {
    icon: 'ri-shield-check-line',
    title: '只用手能追溯的信息',
    desc: '官方通报、公开报道、企业披露文件与当事人的公开表述，是我们可以使用的全部素材。无法追溯来源的内容，一律不写。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '让各方表述都被看见',
    desc: '同一事件中，相关各方的说法会被并列呈现。我们不替任何一方「圆场」，也不替读者下结论。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '情绪留给读者，事实留给我们',
    desc: '标题不夸张，正文不煽动。越是让人气愤或兴奋的线索，越要先冷静核查一遍。',
  },
  {
    icon: 'ri-edit-2-line',
    title: '错了就改，公开更正',
    desc: '如果后续信息推翻了原有判断，我们会在原文显著位置更新并说明修改原因，不悄悄删改。',
  },
];

export const milestones = [
  { year: '2019', title: '深扒观察室创刊', desc: '从三个人的兴趣小组起步，用一份文档梳理第一个公开事件的时间线。' },
  { year: '2021', title: '建立核查清单', desc: '把「孤证不立」写成流程，每篇文章发布前必须完成来源交叉验证。' },
  { year: '2023', title: '推出要点提炼', desc: '在长文开头加入核心要点与证据等级说明，让没有时间的读者也能判断可信度。' },
  { year: '2026', title: '五大主题成型', desc: '内容从娱乐延伸到行业、品牌、社会与文化，形成今天相对完整的选题结构。' },
];